var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FontAwesomeIcon',{staticClass:"ribbon",class:[`ribbon--${_vm.position}`],attrs:{"icon":"bookmark"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _setup.onRibbonClick.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }